import React from "react";
import styled from "styled-components";
import _Link from "gatsby-link";
import Container from "../Container";
import config from "@p14/config";

export const Root = styled.footer`
  color: #fff;
  height: 319px;
  position: relative;
  margin-top: -319px;
  padding-top: 30px;
  padding-bottom: 28px;
  background-color: #1b2333;

  @media ${config.media.tabletOnly} {
    height: 330px;
    margin-top: -330px;
  }

  @media ${config.media.mobile} {
    margin-top: 0;
    height: auto;
  }
`;

export const _Logo = (props) => (
  <a href="http://www.elbert.com.cy/" {...props}>
    <svg viewBox="0 0 298.5 111.4">
      <path
        d="M6.2 4v11.1h12.4V19H6.2v9.7h12.4v4H1.7V0h15.7v4zm34.5 24.7v4H25.3V0h4.4v28.7zM52.5 0c5.7 0 9.4 3.6 9.4 9.1 0 3.3-1.5 6-3.8 7.1 3.5.9 5.7 3.9 5.7 7.8 0 5.6-3.8 8.8-11.1 8.8h-7.9V0zm-3.2 14.7h2.8a5 5 0 0 0 5.4-5.3 5.25 5.25 0 0 0-5.6-5.6h-2.5v10.9zm0 14.3h2.9c4.5 0 6.9-1.8 6.9-5.4 0-3.3-2.8-5.4-6.8-5.4h-3zM74.5 4v11.1h12.4V19H74.5v9.7h12.4v4H70V0h15.7v4zM98 18.1v14.6h-4.4V0h6.8c7.2 0 11.3 4 11.3 10.2 0 4.9-2.5 8.4-6.9 9.8l9.2 12.7h-5.3zm2.5-1.4c3.8 0 6.4-2.3 6.4-6.4S104.3 4 100.5 4H98v12.7zM125.7 4v28.7h-4.4V4h-7.4V0h19.2v4zm-115 35.1c9.9 0 16.2 6.6 16.2 16.4s-6.5 16.3-16.2 16.3h-9V39.1zm0 28.8c6.9 0 11.4-5 11.4-12.4s-4.6-12.3-11.6-12.3H6.1v24.7zm26.5-24.8v11.1h12.4v3.9H37.2v9.7h12.4v4H32.7V39.1h15.7v4zm27.6 28.7l-12-32.7h4.7l9.6 26.5 9.7-26.5h4.6l-12 32.7zm24.6-28.7v11.1h12.4v3.9H89.4v9.7h12.4v4H85V39.1h15.7v4zm34.5 24.7v4h-15.4V39.2h4.4v28.7h11zm33.8-12.2c0 9.9-6.6 16.6-16.3 16.6s-16.3-6.7-16.3-16.7 6.5-16.8 16.3-16.8 16.3 6.8 16.3 16.9zm-27.8-.1c0 7.5 4.6 12.7 11.5 12.7s11.6-5 11.6-12.6-4.6-12.8-11.6-12.8-11.5 5-11.5 12.7zm41.2-16.4c6.9 0 11.3 4.8 11.3 11.7 0 7.1-4.7 11.7-11.8 11.7H168v9.2h-4.4V39.1zm-.6 19.4c4.3 0 7.1-3.2 7.1-7.7s-2.7-7.6-6.8-7.6H168v15.3zm22.3-19.6L203.4 58l10.9-19.1h4.4v32.9h-4.5V46.9l-10.8 18.9L192.8 47v24.9h-4.5v-33zm37.9 4.2v11.1h12.4v3.9h-12.4v9.7h12.4v4h-16.9V39.1H242v4zm39.8 28.7l-16.2-25.1v25.1h-4.5V39.2h4.5l16.2 25.2V39.1h4.4v32.7zm20.6-28.7v28.7h-4.4V43.1h-7.4v-4h19.2v4zM27.9 81.9l-2.2 3.7a12.35 12.35 0 0 0-8.9-3.7c-6.7 0-11.9 5.3-11.9 12.7s5.1 12.7 11.8 12.7c6 0 10.2-4.1 10.3-9.4H15.6V94h15.6v3.6c0 8.1-6 13.8-14.6 13.8-9.8 0-16.6-7.2-16.6-16.7 0-9.9 7-16.8 16.6-16.8a16.86 16.86 0 0 1 11.3 4zm13.7 14.4v14.6h-4.4V78.3H44c7.2 0 11.3 4 11.3 10.2 0 4.9-2.5 8.4-6.9 9.8l9.2 12.7h-5.3zm2.5-1.3c3.8 0 6.4-2.3 6.4-6.4s-2.6-6.3-6.4-6.3h-2.4V95zm48-.2c0 9.9-6.6 16.6-16.3 16.6s-16.3-6.7-16.3-16.7S66 77.9 75.8 77.9s16.3 6.7 16.3 16.9zm-27.9-.2c0 7.5 4.6 12.7 11.5 12.7s11.6-5 11.6-12.6-4.6-12.8-11.6-12.8c-6.8 0-11.5 5.1-11.5 12.7zm58.2 3.5c0 8-4.9 13.3-12.3 13.3-7.2 0-12.2-5.2-12.2-13.3V78.3h4.4v19.5c0 5.7 3.1 9.5 7.9 9.5 4.5 0 7.7-3.6 7.7-9.5V78.3h4.4zm14.5-19.8c6.9 0 11.3 4.8 11.3 11.7 0 7.1-4.7 11.7-11.8 11.7h-2.6v9.2h-4.4V78.3zm-.6 19.3c4.3 0 7.1-3.2 7.1-7.7s-2.7-7.6-6.8-7.6h-2.8v15.3z"
        data-name="Layer 1"
      />
    </svg>
  </a>
);

export const Logo = styled(_Logo)`
  margin: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 126px;
  height: 48px;
  display: block;
  text-decoration: none;
  transition: opacity 0.3s ease 0s;
  will-change: opacity;

  &:hover {
    opacity: 0.6;
  }

  & svg {
    fill: ${config.colors.text};
  }

  @media ${config.media.mobile} {
    width: 158px;
    height: 60px;
    position: static;
    margin-bottom: 46px;
  }
`;

export const Text = styled.p`
  margin: 0;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  margin-bottom: 24px;
  font-family: "Geometria";
`;

export const Copyright = styled.small`
  font-family: Geometria;
  font-size: 12px;
  color: #b48b72;
  text-align: center;
  margin: 0;
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 0;
  text-align: center;
  display: block;

  @media ${config.media.mobile} {
    position: static;
  }
`;

export const Year = styled.small`
  position: absolute;
  font-size: 12px;
  font-family: ${config.fonts.sansSerif};
  right: 0;
  bottom: 77px;
  color: ${config.colors.main};

  @media ${config.media.mobile} {
    right: 20px;
    bottom: 100px;
  }
`;

export const Nav = styled.nav`
  padding-left: 20px;

  @media ${config.media.mobile} {
    margin-top: 20px;
    padding-left: 0;
  }
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  list-style: none;
  justify-content: center;

  @media ${config.media.mobile} {
    flex-direction: column;
  }
`;

export const NavItem = styled.li`
  margin: 0 20px;

  @media ${config.media.mobile} {
    margin: 0 0 20px;
    text-align: center;
  }
`;

export const Link = styled(_Link)`
  color: #fff;
  font-size: 12px;
  text-decoration: none;
  text-transform: uppercase;
  transition: opacity 0.3s ease 0s;
  will-change: opacity;

  &:hover {
    opacity: 0.6;
  }
`;

export const Law = styled.p`
  font-family: Geometria;
  font-size: 12px;
  color: #4a4a4a;
  text-align: center;
  margin: 0;
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 20px;

  @media ${config.media.mobile} {
    position: static;
    margin-top: 8px;
  }
`;

export const Official = styled.p`
  font-family: Geometria;
  font-size: 12px;
  color: #b48b72;
  text-align: center;
  margin: 0;
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 40px;

  @media ${config.media.mobile} {
    position: static;
  }
`;

export const links = [
  {
    href: "/documents",
    text: "Документы",
  },
  {
    href: "/technical-characteristics",
    text: "Технические характеристики",
  },
  {
    href: "/building",
    text: "Строительство",
  },
];

export const Socials = styled.div`
  display: flex;
  margin: 20px 0 24px;
  align-items: center;
  justify-content: center;

  & svg {
    fill: #b48b72;
    display: block;
    transition: opacity 0.3s ease 0s;
    will-change: opacity;
  }

  & a:hover svg {
    opacity: 0.65;
  }
`;

export const Label = styled.img`
  top: 0;
  left: 50%;
  max-height: 100%;
  position: absolute;
  margin-left: 320px;

  @media ${config.media.mobile} {
    left: auto;
    right: 20px;
    margin-left: 0;
    max-height: 200px;
  }
`;

export const Footer = () => (
  <Root>
    <Container style={{ height: "100%", position: "relative" }}>
      <Logo />
      <Text style={{ color: config.colors.main }}>Офис продаж</Text>
      <Text style={{ fontSize: 16 }}>
        Москва
        <br />
        Малая Пироговская улица 14
        <br />
        +7 495 620 62 99
      </Text>

      <Nav>
        <List>
          {links.map((link, index) => (
            <NavItem key={index}>
              <Link to={link.href}>{link.text}</Link>
            </NavItem>
          ))}
        </List>
      </Nav>

      <Official>
        Вы находитесь на официальном сайте застройщика «Пироговская 14»
      </Official>
      <Law>
        Информация на данном сайте не является публичной офертой, определяемой
        ст.437 ГК РФ
      </Law>
      <Copyright>
        © ООО «Элберт Инвестмент» {new Date().getFullYear()}
      </Copyright>
    </Container>
    <Label src="/static/footer-label.png" />
  </Root>
);

export default Footer;
